module.exports = __webpack_public_path__ + "img/9.e8a00d85.jpg";